import React from "react";

const logos = [
  ["redlobster", "jiffylube", "att"],
  ["starbucks", "mattresswarehouse", "aamco"],
  ["applebees", "dq", "petco"],
  ["firestone", "bp", "oreilly"],
  ["jackinthebox", "chipotle", "redrobin"],
  // trulieve, krispykreme
];

class PropertyPortfolio extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="page-image" />
        <div className="container section row" style={{ width: "85%" }}>
          <h5>Property Portfolio</h5>
          <div className="col s12 m12 l8 container">
            <img id="property-map-img" src="/images/properties/property_map.png" />
          </div>
          {/* <div className="section" /> */}
          <div
            className="col s11 offset-m2 m9 l4"
            style={{ paddingLeft: "30px" }}
          >
            <div id="tenants-title">Portfolio Tenants:</div>
            {
              logos.map((row, row_idx) => {
                return (
                  <div className="row" key={row_idx} style={{ marginBottom: "0px" }}>
                    {row.map((company, idx) => {
                      return (
                        <div className="col s4" key={idx}>
                          <a href={`https://www.${company}.com/`}>
                            <img alt={`https://www.${company}.com/`} className="property-logo" src={`/images/logos/${company}.png`} />
                          </a>
                        </div>
                      );
                    })}
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

export default PropertyPortfolio;
